define([
    'jquery',
    'lodash/object/assign',
    'imagerotator/js/imagerotator'
], function($, assign) {
    'use strict';

    function getWordpressViewerConfig() {
        if(!window.__virtualexhibitions360Viewer) {
            throw new Error(
                'Wordpress didn\'t set __virtualexhibitions360Viewer global');
        }
        return window.__virtualexhibitions360Viewer;
    }

    var ThreeSixtyViewerPage = function ThreeSixtyViewerPage(options) {
        this.options = assign({}, this.defaultOptions(), options || {});

        this.$el = $(this.options.el);
        this.$viewer = $('.wr360_player');
        this.createViewer();
    };

    assign(ThreeSixtyViewerPage.prototype, {
        defaultOptions: function() {
            return assign({
                el: 'body'
            }, getWordpressViewerConfig());
        },

        createViewer: function() {
            this.$viewer.rotator({
                // There is no license file for the free version, so no point
                // in making an ajax request. So we use an empty data URL.
                licenseFileURL      : "data:text/plain;base64,",
                configFileURL       : this.options.configUrl,
                graphicsPath        : this.options.graphicsUrl,
                zIndexLayersOn      : true,
                rootPath: '/blah/'
            });
        }
    });

    return ThreeSixtyViewerPage;
});



/** WEBPACK FOOTER **
 ** ./js/view/ThreeSixtyViewerPage.js
 **/